import { render, staticRenderFns } from "./ResetButton.vue?vue&type=template&id=35a3c45a&scoped=true&"
import script from "./ResetButton.vue?vue&type=script&lang=js&"
export * from "./ResetButton.vue?vue&type=script&lang=js&"
import style0 from "./ResetButton.vue?vue&type=style&index=0&id=35a3c45a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3c45a",
  null
  
)

export default component.exports